import React from "react";
import ReportsContainer from "../../container/reports";

const ReportsScreen: React.FC<{}> = () => {
    return <ReportsContainer/>;
}

export default ReportsScreen;